import React from 'react';
import { Card } from './ui/Card';
import { CheckSquare } from 'lucide-react';
export function ActionItemsCard({
  highlighted
}: {
  highlighted?: boolean;
}) {
  return <Card delay={0.6} highlighted={highlighted} data-id="element-1">
      <h2 className="text-2xl text-navy flex items-center gap-2 mb-6" data-id="element-2">
        <CheckSquare className="text-crimson" size={24} data-id="element-3" />
        Action Items
      </h2>

      <ul className="space-y-3" data-id="element-4">
        <li className="flex items-start gap-3" data-id="element-5">
          <div className="mt-1 w-4 h-4 rounded border border-gray-400 flex-shrink-0 bg-white" data-id="element-6" />
          <span className="text-sm text-gray-800" data-id="element-7">
            Send the client a link to the online portal.
          </span>
        </li>
        <li className="flex items-start gap-3" data-id="element-8">
          <div className="mt-1 w-4 h-4 rounded border border-gray-400 flex-shrink-0 bg-white" data-id="element-9" />
          <span className="text-sm text-gray-800" data-id="element-10">
            Follow up with the client after portal completion.
          </span>
        </li>
        <li className="flex items-start gap-3" data-id="element-11">
          <div className="mt-1 w-4 h-4 rounded border border-gray-400 flex-shrink-0 bg-white" data-id="element-12" />
          <span className="text-sm text-gray-800" data-id="element-13">
            Review client's credit and financial information.
          </span>
        </li>
      </ul>
    </Card>;
}